export const HASHTAGS = `
	query hashtags($event_id: Uint) {
		hashtags(event_id: $event_id) {
			id
			event_id
			name
			point_value
		}
	}
`;

export const CREATE_HASHTAG = `
	mutation createHashtag($hashtag: HashtagInput!) {
		createHashtag(hashtag: $hashtag) {
			id
			event_id
			name
			point_value
		}
	}
`;

export const DELETE_HASHTAG = `
	mutation deleteHashtag($id: Uint) {
		deleteHashtag(id: $id) {
			id
		}
	}
`;
